import { combineReducers } from 'redux'

import { reducer as addInvestmentProject } from './addInvestmentProject'
import { reducer as getAllInvestmentProject } from './getAllInvestmentProject'
import { reducer as editInvestmentProject } from './editInvestmentProject'
import { reducer as deleteInvestmentProject } from './deleteInvestmentProject'

export default combineReducers({
    addInvestmentProject,
    getAllInvestmentProject,
    editInvestmentProject,
    deleteInvestmentProject,
})
